import { Spinner, SpinnerSize } from '@fluentui/react';
import React from 'react';
import { translate } from '../../Locales/i18n/localizationService';

export const LoadingSpinner: React.StatelessComponent<{ children?: React.ReactNode; visible: boolean; message?: string; className?: string }> = ({
    children,
    visible,
    message,
    className,
}) => {
    return visible ? (
        <div>
            <div className="pm-spinner-loadspinner">
                <Spinner size={SpinnerSize.large} label={message ?? translate.t('Common.LoadingDot')} className={`tp-spinner ${className}`} />
            </div>
        </div>
    ) : (
        <div>{children}</div>
    );
};
